export var ListingTypes;
(function (ListingTypes) {
    ListingTypes[ListingTypes["AllDesc"] = "All"] = "AllDesc";
    ListingTypes[ListingTypes["All"] = 0] = "All";
    ListingTypes[ListingTypes["SalesDesc"] = "Sales"] = "SalesDesc";
    ListingTypes[ListingTypes["Sales"] = 1] = "Sales";
    ListingTypes[ListingTypes["PriceReducedRentalsDesc"] = "Rentals"] = "PriceReducedRentalsDesc";
    ListingTypes[ListingTypes["Rentals"] = 2] = "Rentals";
})(ListingTypes || (ListingTypes = {}));
